import { computeAbv, computeTlbs } from './tlbs';
import { computeBiasScores } from './biasScore';
import { DEFAULT_PREPROCESS, preprocess } from './preprocess';
import type { PreprocessOptions, ScoredTrial, SessionScores } from './types';

export function scoreSession(trials: readonly ScoredTrial[], opts: PreprocessOptions = DEFAULT_PREPROCESS): SessionScores {
  const { valid, report } = preprocess(trials, opts);
  const answered = trials.filter((t) => !t.aborted && !t.timedOut && t.correct !== null);
  const attempted = trials.filter(t => !t.aborted);
  const correct = answered.filter(t => t.correct === true).length;
  return {
    preprocess: report,
    bias: computeBiasScores(valid),
    tlbs: computeTlbs(valid),
    abv: computeAbv(valid, 20, trials),
    accuracy: attempted.length ? correct / attempted.length : null,
    performance: { attempted: attempted.length, answered: answered.length, correct, timedOut: attempted.filter(t => t.timedOut).length, responseAccuracy: answered.length ? correct / answered.length : null },
    validTrials: valid.length,
  };
}

export { preprocess, DEFAULT_PREPROCESS } from './preprocess';
export { computeBiasScores } from './biasScore';
export { computeTlbs, computeAbv, tlbsSeries } from './tlbs';
export { cohortSplitHalf, type CohortReliability } from './reliability';
export * from './types';
